import React from 'react'
import {WuIcon} from '@npm-questionpro/wick-ui-lib'
import styles from './CustomFileUploader.module.scss'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {IDEATION} from '../../Translation/English/ideation'

interface ICustomFileUploaderProps {
  fileTypes?: string[]
}

export const CustomFileUploader: React.FC<ICustomFileUploaderProps> = ({
  fileTypes,
}) => {
  const wt = useWt()

  return (
    <div className={styles.fileUploader}>
      <WuIcon icon="wm-cloud-upload" className={styles.fileUploaderIcon} />
      <div>
        {wt(IDEATION.dragPlaceholder)}
        <span className={styles.fileUploaderBrowse}>{wt(IDEATION.browse)}</span>
      </div>
      <span>{fileTypes?.map(file => `${file} `)}</span>
    </div>
  )
}
